import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonService, DocumentService } from '@app/shared/services';
import { label } from '@unovis/ts/components/axis/style';
import { AnimationOptions } from 'ngx-lottie';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'reminder-suggestion',
  templateUrl: './reminder-suggestion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReminderSuggestionComponent implements OnInit, OnDestroy {
  @Output() createReminderEvent = new EventEmitter<void>();
  @Output() createReminderWithSuggestionEvent = new EventEmitter<any>();
  @Output() reminderLoadingDone = new EventEmitter<any>();
  @Output() formattedListChange = new EventEmitter<any[]>();
  @Input() inlineComponent = false;
  @Input() reminder_configurations_list = [];
  @Input() currentFormId;
  @Input() form_id;
  @Input() triggerTypeList;
  @Input() formValue;
  @Input() reminderList;

  triggerTypeOptions = [];
  formatted_reminder_list = [];
  subscription = new Subscription();
  suggestionData = [1, 2, 3];

  allInsuranceAttributeData = [];
  is_loading = true;
  reminder_object_list;
  allFinancialAttributeData = [];
  animation: AnimationOptions = {
    path: '/assets/lottie/ReminderAnimationNew.json',
  };
  timeline_period_type_list = [
    { label: 'Days', value: 'day' },
    { label: 'Months', value: 'month' },
    { label: 'Years', value: 'year' },
    { label: 'Quarter', value: 'quarter' },
  ];

  constructor(
    private http: HttpClient,
    private cd: ChangeDetectorRef,
    private commonService: CommonService,
    private documentService: DocumentService
  ) {}
  addReminder() {
    this.createReminderEvent.emit();
  }
  filterReminders(items: any[], filter_list: any[]): any[] {
    return items.filter((element) => filter_list.findIndex((x) => x.suggestion_type === element.object_config.type.toLocaleLowerCase()) === -1);
  }

  addReminderWithSuggestion(event) {
    const filteredSuggestion = this.filterReminders(this.formatted_reminder_list, this.reminderList);
    const filteredList = filteredSuggestion.filter((item) => item.label.trim() !== event.label.trim());
    if (event.is_disable) {
      return;
    }
    this.createReminderWithSuggestionEvent.emit({
      label: event.label,
      display_text: event.object_config.display_text,
      display_subtext: event.object_config.display_subtext,
      suggestedReminderAdded: filteredList.length === 0,
    });
  }
  formatDate = (date: Date): string => {
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };
  ngOnInit(): void {
    this.triggerTypeList.forEach((element, index) => {
      let value = this.formValue.dynamicFieldsForm[0][element['formControlName']];
      this.triggerTypeOptions.push({
        label: element.label,
        value: element.formControlName,
        is_disable: value === null || value === undefined || value === '' ? true : false,
      });
    });
    this.formatted_reminder_list = [];
    this.is_loading = true;
    this.subscription.add(
      this.commonService.getReminderConfigJSON().subscribe((res) => {
        this.reminder_configurations_list.forEach((element) => {
          if (res[0].config.find((x) => x.type?.trim().toLowerCase() == element?.trim().toLowerCase())) {
            this.formatted_reminder_list.push({
              type: res[0].type,
              error_message: '',
              label: element,
              start_date: '',
              is_disable: false,
              calculateDate: {
                timeline_period: '',
                trigger_date: '',
                timeline_period_type: '',
                timeline_finish_date: '',
                timeline_start_date: '',
                delay_from_start_date: '',
                delay_from_start_date_period: '',
                delay_from_start_date_period_type: '',
              },
              calculate_trigger_date: '',
              object_config: res[0].config.find((x) => x.type?.trim().toLowerCase() == element?.trim().toLowerCase()),
            });
          } else if (res[1].config.find((x) => x.type?.trim().toLowerCase() == element?.trim().toLowerCase())) {
            this.formatted_reminder_list.push({
              type: res[1].type,
              label: element,
              error_message: '',
              start_date: '',
              is_disable: false,
              calculate_trigger_date: '',
              calculateDate: {
                timeline_period: '',
                trigger_date: '',
                timeline_period_type: '',
                timeline_finish_date: '',
                timeline_start_date: '',
                delay_from_start_date: '',
                delay_from_start_date_period: '',
                delay_from_start_date_period_type: '',
              },
              object_config: res[1].config.find((x) => x.type?.trim().toLowerCase() == element?.trim().toLowerCase()),
            });
          } else {
            // this.formatted_reminder_list.push({
            //   type: '',
            //   label: element,
            //   is_disable: false,
            //   object_config: '',
            // });
          }
        });
        this.processFormattedList();
        this.subscription.add(
          this.subscription.add(
            this.documentService.getInsuranceAttribute().subscribe(
              (data) => {
                let key_list = Object.keys(data);
                this.allInsuranceAttributeData = [];
                key_list.forEach((element) => {
                  this.allInsuranceAttributeData.push({
                    vault_form_code: data[element].vault_form_code,
                    title: data[element].title,
                  });
                });
                this.subscription.add(
                  this.documentService.getFinancialAttribute().subscribe(
                    (data) => {
                      let key_list = Object.keys(data);

                      this.allFinancialAttributeData = [];
                      key_list.forEach((element) => {
                        this.allFinancialAttributeData.push({
                          vault_form_code: data[element].vault_form_code,
                          title: data[element].title,
                        });
                      });

                      this.subscription.add(
                        this.documentService.getreminderObjectlist(this.form_id, this.currentFormId).subscribe((res) => {
                          try {
                            this.reminder_object_list = res;
                            this.reminder_object_list.forEach((element) => {
                              if (
                                element.type == 'financial_attributes' &&
                                this.allFinancialAttributeData.findIndex((x) => x.vault_form_code == element.value) >= 0
                              ) {
                                let find_element = this.allFinancialAttributeData.find((x) => x.vault_form_code == element.value);
                                element.label = find_element.title;
                              }
                              if (
                                element.type == 'insurance_attributes' &&
                                this.allInsuranceAttributeData.findIndex((x) => x.vault_form_code == element.value) >= 0
                              ) {
                                let find_element = this.allInsuranceAttributeData.find((x) => x.vault_form_code == element.value);
                                element.label = find_element.title;
                              }
                            });
                            this.formatted_reminder_list.forEach((element) => {
                              if (element.object_config.config.findIndex((x) => x.field?.trim().toLowerCase() == 'trigger date') >= 0) {
                                let find_element = element.object_config.config.find((x) => x.field?.trim().toLowerCase() == 'trigger date');
                                let default_value: string = find_element.default.replace(/[<>]/g, '');

                                this.triggerTypeList.forEach((trigger_type_element) => {
                                  if (trigger_type_element.label.toLowerCase().trim() == default_value.toLowerCase().trim()) {
                                    if (
                                      this.formValue.dynamicFieldsForm[0][trigger_type_element.formControlName] != '' &&
                                      this.formValue.dynamicFieldsForm[0][trigger_type_element.formControlName] != undefined &&
                                      this.formValue.dynamicFieldsForm[0][trigger_type_element.formControlName] != null
                                    ) {
                                      element.is_disable = false;
                                      element.start_date = this.formValue.dynamicFieldsForm[0][trigger_type_element.formControlName];
                                    } else {
                                      element.is_disable = true;
                                      element.error_message = `${trigger_type_element.label} is missing`;
                                    }
                                  }
                                });
                                if (element.object_config.config.findIndex((x) => x.default == '<Today>') >= 0) {
                                  element.is_disable = false;
                                  element.start_date = this.formatDate(new Date());
                                }
                              }
                              if (
                                element.object_config &&
                                element.object_config.config.findIndex((x) => x.field?.trim().toLowerCase() == 'object') >= 0
                              ) {
                                let find_config = element.object_config.config.find((x) => x.field?.trim().toLowerCase() == 'object');
                                let current_date = this.reminder_object_list.find(
                                  (x) =>
                                    x.label?.trim().toLowerCase() == find_config.default.trim().toLowerCase() &&
                                    (x.type == 'financial_attributes' || x.type == 'insurance_attributes' || x.type == 'role_players')
                                );
                                if (current_date && current_date.max_data == null) {
                                  element.error_message = `${current_date.label} is missing`;
                                  element.is_disable = true;
                                }
                              }
                            });
                            this.calculateTriggerDate();
                            this.processFormattedList();
                          } catch (error) {}
                          this.is_loading = false;
                          this.reminderLoadingDone.emit();

                          this.cd.detectChanges();
                        })
                      );
                    },
                    (error) => {
                      console.error(error);
                    }
                  )
                );
              },
              (error) => {
                console.error(error);
              }
            )
          )
        );
      })
    );
  }

  isNotNullEmpty(value) {
    if (value == null || value == undefined || value == '') {
      return true;
    } else {
      return false;
    }
  }

  getNextDate(inputDateString: string): string {
    // Get the current date and year
    const today = new Date();
    const currentYear = today.getFullYear();

    // Split the input date string into month and day parts
    const [monthString, dayString] = inputDateString.split(' ');
    const day = parseInt(dayString.replace('th', '').replace('st', '').replace('nd', '').replace('rd', ''));

    // Map the month string to a month number (0-based)
    const monthMap: { [key: string]: number } = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };
    const month = monthMap[monthString];

    // Create a date object for the parsed month and day in the current year
    let nextDate = new Date(currentYear, month, day);

    // If the date is before today, move to next year
    if (nextDate < today) {
      nextDate.setFullYear(currentYear + 1);
    }

    // Format the date as yyyy/MM/dd
    const formattedNextDate = nextDate.toISOString().split('T')[0].replace(/-/g, '/');

    return formattedNextDate;
  }

  parseInput(input: string): { value: number; unit: string } {
    const [value, unit] = input.split(/\/|\s+/);
    return { value: parseFloat(value), unit: unit.trim() };
  }
  findBestMatch(input: string): string {
    const normalizedInput = input.toLowerCase();
    const match = this.timeline_period_type_list.find(
      (periodType) => periodType.label.toLowerCase() === normalizedInput || periodType.value.toLowerCase() === normalizedInput
    );
    return match ? match.value : '';
  }

  calculateDate(root_index) {
    if (
      (this.formatted_reminder_list[root_index].calculateDate.timeline_start_date != '' ||
        this.formatted_reminder_list[root_index].calculateDate.timeline_finish_date != '') &&
      this.formatted_reminder_list[root_index].calculateDate.timeline_period_type != '' &&
      this.formatted_reminder_list[root_index].calculateDate.timeline_period != ''
    ) {
      if (this.formatted_reminder_list[root_index].calculateDate.timeline_future_date_is == 'Start by Date') {
        let timeline_start_date = this.formatted_reminder_list[root_index].calculateDate.timeline_start_date;
        if (
          this.formatted_reminder_list[root_index].calculateDate.delay_from_start_date &&
          this.formatted_reminder_list[root_index].calculateDate.delay_from_start_date_period &&
          this.formatted_reminder_list[root_index].calculateDate.delay_from_start_date_period_type
        ) {
          timeline_start_date = this.commonService.calculateNextDate(
            timeline_start_date,
            this.formatted_reminder_list[root_index].calculateDate.delay_from_start_date_period,
            this.formatted_reminder_list[root_index].calculateDate.delay_from_start_date_period_type,
            true
          );
        }
        let nextDate = this.commonService.calculateNextDate(
          timeline_start_date,
          this.formatted_reminder_list[root_index].calculateDate.timeline_period,
          this.formatted_reminder_list[root_index].calculateDate.timeline_period_type,
          true
        );
        if ((nextDate as any) != 'Invalid Date') {
          this.formatted_reminder_list[root_index].calculateDate.timeline_finish_date = nextDate;
        }
      } else {
        let nextDate = this.commonService.calculateNextDate(
          this.formatted_reminder_list[root_index].calculateDate.timeline_finish_date,
          this.formatted_reminder_list[root_index].calculateDate.timeline_period,
          this.formatted_reminder_list[root_index].calculateDate.timeline_period_type,
          false
        );
        if ((nextDate as any) != 'Invalid Date') {
          this.formatted_reminder_list[root_index].calculateDate.timeline_start_date = nextDate;
        }
      }
    }
    this.processFormattedList();
    this.cd.detectChanges();
  }
  calculateTriggerDate() {
    this.formatted_reminder_list.forEach((root_element, root_index) => {
      let configurationFieldList = root_element.object_config.config;
      let object_config = configurationFieldList.find((x) => x.field.trim().toLowerCase() == 'object');
      let findObjectInTheList =
        this.reminder_object_list.find((x) => x.label.trim().toLowerCase() == object_config.default.toLowerCase()) ??
        this.reminder_object_list.find((x) => x.label.trim().toLowerCase() == 'other');
      if (findObjectInTheList.value) {
        if (findObjectInTheList.type.toLowerCase() == 'other') {
        } else if (findObjectInTheList.max_data) {
          root_element.calculateDate.timeline_start_date = findObjectInTheList.max_data;
        } else {
          root_element.calculateDate.timeline_start_date = '';
        }
      }

      configurationFieldList.forEach((element, index) => {
        if (this.isNotNullEmpty(element.default)) {
        } else if (element.field.trim() == 'Owner') {
        } else if (element.field.trim() == 'Action') {
        } else if (element.field.trim() == 'Object') {
        } else if (element.field.trim() == 'Schedule') {
        } else if (element.field.trim() == 'Delay') {
          if (element.default == 'Off') {
            return;
          }
          try {
            let defaultValue = this.parseInput(element.default);
            root_element.calculateDate.delay_from_start_date_period = defaultValue?.value ? defaultValue?.value.toString() : '';
            root_element.calculateDate.delay_from_start_date_period_type = this.findBestMatch(defaultValue.unit);
            root_element.calculateDate.delay_from_start_date = true;
          } catch (error) {
            console.error('*** Delay ***', error);
          }
        } else if (element.field.trim() == 'Time To Complete') {
          if (element.default == 'Off') {
            return;
          }

          try {
            let defaultValue = this.parseInput(element.default);
            root_element.calculateDate.timeline_period = defaultValue?.value ? defaultValue?.value.toString() : '';
            root_element.calculateDate.timeline_period_type = this.findBestMatch(defaultValue.unit);
          } catch (error) {
            console.error('*** Time To Complete ***', error);
          }
        } else if (element.field.trim() == 'Trigger Date') {
          let default_value: string = element.default.replace(/[<>]/g, '');
          this.triggerTypeOptions.forEach((element) => {
            if (element.label.toLowerCase() == default_value.toLowerCase()) {
              if (element.is_disable == false) {
                root_element.calculateDate.trigger_date = element.value;
              }
            }
          });
        } else if (element.field.trim() == 'Start') {
          try {
            if (element.default == 'Auto-populated') {
              root_element.calculateDate.timeline_future_date_is = 'Finish by Date';
              let nextDate = new Date(this.formValue.dynamicFieldsForm[0][root_element.calculateDate.trigger_date]);
              if ((nextDate as any) != 'Invalid Date') {
                root_element.calculateDate.timeline_finish_date = nextDate;
              }
            } else {
              let outputData = this.getNextDate(element.default);
              let outputData_value = new Date(outputData);
              if (root_element.calculateDate.timeline_future_date_is == 'Finish by Date') {
                root_element.calculateDate.timeline_finish_date = outputData_value;
              }
              if (root_element.calculateDate.timeline_future_date_is == 'Start by Date') {
                root_element.calculateDate.timeline_start_date = outputData_value;
              }
            }

            this.calculateDate(root_index);
          } catch (error) {
            console.error('*** Start ***', error);
          }
        } else if (element.field.trim() == 'Finish') {
          try {
            if (element.default == 'Auto-populated') {
              root_element.calculateDate.timeline_future_date_is = 'Start by Date';
              let nextDate = new Date(this.formValue[root_element.calculateDate.trigger_date.value]);
              if ((nextDate as any) != 'Invalid Date') {
                root_element.calculateDate.timeline_start_date = nextDate;
              }
            }

            this.calculateDate(root_index);
          } catch (error) {
            console.error('*** Start ***', error);
          }
        } else if (element.field.trim() == 'Future Date Is') {
          if (element.default.trim() == 'Finish by Date') {
            root_element.calculateDate.timeline_future_date_is = 'Finish by Date';
          }
          if (element.default.trim() == 'Start by Date') {
            root_element.calculateDate.timeline_future_date_is = 'Start by Date';
          }

          this.calculateDate(root_index);
        } else if (element.field.trim() == 'Trigger Date Is') {
          if (element.default.trim() == 'Finish Date') {
            root_element.calculateDate.timeline_future_date_is = 'Finish by Date';
          }
          if (element.default.trim() == 'Start Date') {
            root_element.calculateDate.timeline_future_date_is = 'Start by Date';
          }

          this.calculateDate(root_index);
        }
      });
    });
  }

  processFormattedList() {
    this.formattedListChange.emit(this.formatted_reminder_list);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
